import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import moment from 'moment'

i18n.use(LanguageDetector).init({
  // we init with resources
  resources: {
    en: {
      main: {
        example_location: 'Where to',
        people: 'People',
        anytime: 'When',
        all_for_you: 'All for you',
        guided_activities: 'Guided Activities',
        guru_tailored_tours: 'Trip Guru',
        date_format: '{{date, YYYY/MM/DD}}',
        loading: 'Loading',
        main_title: 'Personalized Trip Plans & Activities',
        main_description: 'Save time & money - get a memorable experience ',
        content: 'Content here!',
        my_trips: 'My Trips',
        my_plans: 'My Plans',
        trip_activities: 'Trips / Activities',
        become_a_guide: 'Become a Guide',
        become_a_travel_guru: 'Become a Travel Guru',
        become_an_activity_guide: 'Become an Activity Guide',
        help: 'Help',
        login: 'Login',
        signup: 'Sign Up',
        logout: 'Log Out',
        my_profile: 'My profile',
        my_orders: 'My orders',
        reviews: 'Reviews',
        settings: 'Settings',
        messages: 'Messages',
        home: 'Home',
        signup_title: 'Please complete your registration',
        email: 'E-mail',
        first_name: 'First Name',
        last_name: 'Last Name',
        phone: 'Phone',
        birthday: 'Birthday',
        name: 'Name',
        gender: 'Gender',
        save_continue: 'Save & Continue',
        browse: 'Browse...',
        remove: 'Remove',
        price: 'Price',
        enter_price: 'Enter price',
        select_currency: 'Select currency',
        currency: 'Currency',
        days: 'Days',
        duration: 'Duration',
        required_field: 'This field is required',
        length: '80 chars required',
        birth: '18 years old is required',
        location_must_include_country: 'Location must include country',
        file_size_limit: 'The file size must be less then {{sizeMB}}MB',
        file_type_error: 'The file type must be {{fileType}}',
        website_error: 'Website is invalid',
        hour: 'Hour',
        hours: 'Hours',
        minutes: 'Minutes',
      },
      img_bank: {
        title: 'Choose Your Images',
        search_help: 'Search the photo collections',
        input_placeholder: 'Type your keyword',
        upload_photo: 'Upload a Photo',
        select: 'Select'
      },
      guru: {
        details: 'Details',
        description: 'Description',
        location: 'Location',
        languages: 'Languages',
        photos: 'Add photos',
        service_locations: 'Service Locations',
        category: 'Category',
        special_expertise: 'Special Expertise',
        service_description: 'Service Description',
        tailored_trips: 'Tailored Trip Cost',
        additional_services: 'Additional Services',
        upload_example: 'Upload Example',
        pay_pal: 'Payment',
        pay_pal_description: 'Add your PayPal email account so we can send money to your account. ',
        pal_pal_description_example: 'This account david@david.com allow us to pay you.',
        short_description_placeholder: 'Type your short description (600 characters only)',
        short_description: 'Write a short description about yourself',
        short_description_example:
          'Sound personable, Highlight your expertise. Show why you’re qualified to plan trips. Mention any unique skills, credentials, or even life experience that make you a credible trip guru. Let your personality shine through. Try ending with a fun fact or interesting personal detail to avoid sounding too formal.',
        special_expertise_description:
          'Choose the specialities that best describe your special experience (for example, people with disabilities).',
        my_details: 'My Details',
        example_file_spec: 'File type: PDF, Max Size: 10 M',
        example_file_instructions: 'Please upload example plan for your potential customers',
        example_file_title: 'Upload Example Plan',
        uploaded_file: 'Uploaded file',
        expertise_duplicate_error: 'Each expertise must be chosen once',
        select_expertise_placeholder: 'Select expertise',
        add_expertise: 'Add expertise (optional)',
        your_profile_title: 'Your Profile looks good!',
        your_profile_summary_title: 'Your Ideal Trip Guru',
        add_location: 'Add location (optional)',
        unique_location_error: 'Each location must be chosen once',
        select_language: 'Select language',
        add_language: 'Add language',
        example_location: 'example: Shinjuku Station',
        location_title: 'Location of your travel expertise',
        location_description_title: 'Add locations where you are a great expert that can provide a detailed plan to travelers.',
        category_title: 'Category',
        category_description_title: 'Choose the categories that best describe your experience. Select all if you are an expert in all.',
        home_location_title: 'My life is based in...',
        customer_service_expectation:
          'What your customer can expect to get from you in terms of travel plan, communication and support while creating the plan.',
        service_description_example:
          'What your customer can expect to get from you in terms of travel plan, communication and support while creating the plan.',
        service_description_title: 'Service Description',
        service_description_message: 'Type your short description (800 characters only)',
        additional_services_title: 'Additional Travel Services',
        additional_services_message: 'Add some additional services you can provide to your travelers, and you are an expert in.',
        additional_services_placeholder: 'Service title',
        add_service: 'Add Service',
        enter_plan_name: 'Enter plan name',
        plan_name: 'Plan name',
        destination: 'Destination',
        add_trip: 'Add Trip (optional)',
        duplicate_services_error: 'Each service must be chosen once',
        plans_PayPerDay: 'Pay Per Day',
        plans_PayOneWeekPeriod: 'Pay For a Week',
        plans_PayTwoWeekPeriod: 'Pay For Two Weeks',
        plans_PayThreeWeekPeriod: 'Pay For Three Weeks',
        plans_PayForMonth: 'Pay For Up To a Month',
        plans_PayForMoreThanMonth: 'Pay For More Than a Month',
        tailored_trip_plans_cost: 'Tailored Plans and Pricing',
        tailored_trip_plans_cost_description:
          'Add pricing to the tailored plans for your destinations. The price of your service is entirely up to you. You can set a few options for a destination such as a price per day, week and so on.',
        plan_payment_structure: 'Pricing Option',
        what_will_you_get: 'What will you get',
        guru_including_title: 'A detailed trip plan for your stay including',
        tailored_itineraries: 'Tailored daily itineraries',
        information_advices: 'Information & advices',
        tips_for: 'Tips for attractions, nightlife and restaurants',
        food_suggestions: 'Food suggestions',
        special_events: 'Special events during your stay',
        personal_app: 'Personal mobile app',
        online_offering: 'Online connection to build your tailored trip based on your interests, budget and dates. I will contact you and you’ll be able to add more travel details and to ask any question you may have.',
        reviews: "review(s)",
        about_me: "About me"
      },
      guide: {
        details: 'Details',
        description: 'Description',
        location: 'Location',
        languages: 'Languages',
        photos: 'Add Photos',
        category: 'Category',
        finish: 'Finish',
        main_info: 'Main Info',
        remove: 'Remove',
        select_category: 'Select category',
        solves_questions: 'solves all your questions',
        add_category: 'Add category (optional)',
        short_description_placeholder: 'Type your short description (600 characters only)',
        short_description_example:
          'Sound personable, Highlight your expertise. Show why you’re qualified to plan trips. Mention any unique skills, credentials, or even life experience that make you a credible trip guru. Let your personality shine through. Try ending with a fun fact or interesting personal detail to avoid sounding too formal.',
        short_description: 'Write a short description about yourself',
        save_continue: 'Save & Continue',
        my_details: 'My Details',
        your_profile_title: 'Your Profile looks good!',
        your_profile_summary_title: 'Here is your expert profile summary',
        select_language: 'Select language',
        add_language: 'Add language',
        add_location: 'Add location (optional)',
        unique_location_error: 'Each location must be chosen once',
        example_location: 'example: Shinjuku Station',
        location_title: 'Country',
        langueges_label: 'Defines the languages in which the tour is provided',
        home_location_title: 'My life is based in...',
        add_photos: 'Add Photos',
        quality_photos: 'Add your quality photos',
        chance_picked: 'Photos increase the chance to be picked by 80%! Show off your experience with 3 great photos.',
        what_you_get: 'What will you get',
        detailed_plan: 'A detailed trip plan that',
        solves_question: 'solves all your questions',
        online_support: 'Online support that',
        helps_you: 'helps you each step of your trip',
        about_me: 'About me'
      },
      activity_steps: {
        main_info: 'Main info',
        type_title: 'Activity title',
        add_tags: 'Add tags for optimal search results',
        languages: 'Languages',
        category: 'Category',
        category_description_title: 'Choose the categories that best describe the activity.',
        categories: 'Categories',
        select_category: 'Select category',
        add_category: 'Add category (optional)',
        defines_languages: 'Define the languages in which the activity is provided to your travelers',
        select_language: 'Select language',
        add_language: 'Add language (optional)',
        add_photos: 'Add Photos',
        quality_photos: 'Add your quality photos',
        chance_picked: 'Photos increase the chance to be picked by 80%! Show off your experience with 3 great photos.',
        more_details: 'More details',
        'what-to-do': "What We'll do",
        'title-tags': 'Title, location, tags',
        tags_placeholder: 'type tags: fun, family, shop',
        description: 'Description',
        short_description_placeholder: 'Type your short description (4000 characters only)',
        short_description: 'Write a short description about the activity',
        trip_title: 'Activity Title and Location',
        what_we_do: "What we'll do",
        activity_description: 'Describe in detail what you’ll be doing with your travelers. The more information you can give, the better.',
        where_description: 'Name all the locations you’ll visit with your travelers. Give travelers a reason to why they’re meaningful',
        provide_description:
          'Here you can add additional details about what you are providing to your travelers. For example, drinks, tickets, etc',
        bring_description: 'Write a short description of what your travelers need to bring to your trip',

        example_description_spec:
          'example: A trip for the whole family. 14 days of fun in the sun. Go for a shopping trip at the cheapest stores! ',
        where_description_spec: 'Example: we will go to the best shopping stores in tokyo: Shinjuku, Shibuya and Harajuku!',
        provide_spec: 'Example: train tickets, 100$ discount at Harajuku',
        where_will_be: "Where we'll be",
        what_you_provide: 'What you will provide',
        what_i_provide: 'What I provide',
        what_bring: 'What do you need to bring',
        need_to_bring: 'What people needs to bring',
        bring_spec:
          'Mention anything that travelers will have to bring with them or arrange on their own, like transportation, comfortable shoes, sunscreen, etc.',
        add_info: 'Add Info',
        security_notice: 'Security Notice',
        weather_notice: 'Weather Notice',
        security_example: 'Mention anything that travelers will have to know in terms of security.',
        weather_example:
          'Mention anything that travelers will have to know in terms of weather like bring your umbrella, OR summer week should bring a bottle of water.',
        meeting_point_description:
          'Let travelers know exactly where you’ll be meeting. The exact address won’t be shared with guests until they book.',
        times_location: 'Times / Location',
        meeting_point: 'Meeting point',
        example_location: 'Example: Shinjuku Station',
        length_price: 'Tour Length, Group Size and Price',
        tour_length: 'Tour length',
        hours_day: 'hours a day',
        group_size: 'Group size',
        tour_price: 'Tour price',
        tour_price_description: 'The price of your tour is entirely up to you.',
        currency_label: 'Currency',
        price_per_person: 'Price Per Person',
        private_tour: 'Price for a private tour',
        trip_dates: 'Event dates',
        meet_travelers: 'Choose where you are going to meet with your travelers!',
        event_dates: "Event's dates",
        add_event: 'Add event (optional)',
        add_notes: 'Add notes',
        publish_activity: 'Publish Activity',
        starting_hour: 'Starting hour',
        duration: 'Duration',
        repeat: 'Repeat',
        endDate: 'End date',
        booking_notice: 'Booking notice',
        notify_people: 'Define when to notify travelers about the event.',
        days_before: 'days before',

        private_tour_price: 'Private tour price',
        group_price: 'Group price',
        view_details: 'View details'
      },
      create_trip: {
        order: 'Order',
        page_title: 'Create Trip',
        name_and_date: 'Name & Date',
        name_label: 'Name',
        full_name_label: 'Full Name',
        name_placeholder: 'Type Trip Name',
        start_date: 'Start Date',
        end_date: 'End Date',
        total_days: 'Total Days',
        description_label: 'Write a short description about your trip',
        description_example: 'Example: train tickets, $100 discount at Harajuku',
        description_placeholder: 'Type your short description (100 characters only)',
        budget: 'Budget',
        for_person: 'For Person',
        total: 'Total',
        currency: 'Currency',
        travelers: 'Travelers',
        traveler_name_placeholder: 'Full Name',
        traveler_age: 'Age',
        add_another_traveler: 'Add another traveler',
        add_cover_photo: 'Add cover photo',
        next: 'Next',
        day_prefix: 'Day '
      },
      overview: {
        what_we_do: "What we'll do",
        where_will_be: "Where we'll be",
        what_you_provide: 'What you provide',
        what_i_provide: 'What I provide',
        what_bring: 'What do you need to bring',
        bring_spec: 'Example: Comfortable shoes, Sunscreen',
        add_info: 'Add Info',
        security_notice: 'Security Notice',
        weather_notice: 'Weather Notice',
        see_dates: 'See dates',
        choose: 'Choose',
        show_more: 'Show more'
      },
      profile: {
        title: 'Edit Profile',
        pr_picture: 'Profile Picture',
        first_name: 'First Name',
        first_name_placeholder: 'Type your first name',
        last_name: 'Last Name',
        last_name_placeholder: 'Type your first name',
        male: 'Male',
        female: 'Female',
        other: 'Other',
        birthday: 'Birthday',
        gender: 'Gender',
        email: 'Email Address',
        email_placeholder: 'Type your email address',
        phone_placeholder: 'Type your phone address',
        phone: 'Phone Number',
        pref_language: 'Preferred Language',
        pref_curency: 'Preferred Curency',
        country: 'Country',
        english: 'English',
        spanish: 'Spanish',
        hebrew: 'Hebrew',
        save: 'Save',
        help_names:
          'Your public profile only shows your first name. When you request a booking, your guide will see your first and last name.',
        help_birthday: 'We use this info for analysis and never share it with other users.',
        help_gender: 'We use this info for analysis and never share it with other users. ',
        help_email:
          'We would not share your private email address with other users. This is only shared once you have a confirmed booking with another user. This is how we can all get in touch.',
        help_phone:
          'We would not share your private phone number with other users. This is only shared once you have a confirmed booking with another user. This is how we can all get in touch.',
        help_language: 'Your preferred language for communication. ',
        help_currency: 'We will show you prices in this currency.',
        help_country: 'People are curious about where you’re from.',
        help_avatar: 'The first thing people see is your photo, so show them your best side.'
      },
      create_poi: {
        page_title: 'Create POI',
        find_poi: 'Find POI',
        places_label: 'Places',
        places_placeholder: 'Search a place',
        link_label: 'Link',
        link_placeholder: 'Enter Link or Web Site Url',
        location_label: 'Location',
        location_placeholder: 'Type location',
        phone_label: 'Phone',
        phone_placeholder: 'Phone #',
        description_label: 'Write a short description about POI',
        description_example: 'Example: Great Sushi place in Shiboya, next to the Zara shop',
        description_placeholder: 'Type your short description (4000 characters only)',
        add_photo: 'Add Photo',
        working_hours: 'Working Hours',
        save_and_exit: 'Save & Exit'
      },
      poi_review: {
        description_label: 'Your first-hand experiences really help other travellers.',
        description_example: 'Your experience with this POI',
        description_placeholder: 'Some placehlder',
        text_p2: '" next to this review.',
        agriment: 'I agree with the terms and conditions of submitting this review.',
        text_p1: 'We\'ll show your name as "',
        save: 'Save'
      },
      tripGuru_review: {
        description_label: 'Your first-hand experiences really help other travellers.',
        description_example: 'Your experience with this TripGuru',
        description_placeholder: 'Some placehlder',
        text_p2: '" next to this review.',
        agriment: 'I agree with the terms and conditions of submitting this review.',
        text_p1: 'We\'ll show your name as "',
        save: 'Save'
      },
      localTour_review: {
        description_label: 'Your first-hand experiences really help other travellers.',
        description_example: 'Your experience with this activity',
        description_placeholder: 'Some placehlder',
        text_p2: '" next to this review.',
        agriment: 'I agree with the terms and conditions of submitting this review.',
        text_p1: 'We\'ll show your name as "',
        save: 'Save'
      },
      edit_poi: {
        page_title: 'Edit POI',
        find_poi: 'Find POI',
        places_label: 'Places',
        places_placeholder: 'Search a place',
        link_label: 'Link',
        link_placeholder: 'Enter Link or Web Site Url',
        location_label: 'Location',
        location_placeholder: 'Type location',
        phone_label: 'Phone',
        phone_placeholder: 'Phone #',
        description_label: 'Write a short description about POI',
        description_example: 'Example: Great Sushi place in Shiboya, next to the Zara shop',
        description_placeholder: 'Type your short description (4000 characters only)',
        add_photo: 'Add Photo',
        working_hours: 'Working Hours',
        save_and_exit: 'Update'
      },
      add_notes: {
        page_title: 'Add notes',
        title_label: 'Title',
        title_placeholder: 'Title',
        description: 'Description',
        create: 'Create',
        description_label: 'Write a short description about your note',
        description_example: 'Example: train tickets, $100 discount at Harajuku',
        description_placeholder: 'Type your short description (100 characters only)',
        save_and_exit: 'Save'
      },
      edit_notes: {
        page_title: 'Edit notes',
        title_label: 'Title',
        title_placeholder: 'Title',
        description: 'Description',
        create: 'Create',
        description_label: 'Write a short description about your note',
        description_example: 'Example: train tickets, $100 discount at Harajuku',
        description_placeholder: 'Type your short description (100 characters only)',
        save_and_exit: 'Save'
      },
      event: {
        page_title: 'Event',
        category_label: 'Category',
        category_placeholder: 'Select Category',
        sub_category_label: 'Sub Category',
        sub_category_placeholder: 'Select Sub Category',
        title_label: 'Title',
        title_placeholder: 'Type your title',
        places: 'Places',
        place_label: 'Place',
        place_placeholder: 'Search a place',
        link__label: 'Link',
        link__placeholder: 'Type link',
        location_label: 'Location',
        location_placeholder: 'Search a location',
        description_label: 'Write a short description about Event',
        description_example: 'Example: The open Museum of art is a favorite place in Hakone',
        description_placeholder: 'Type your short description (4000 characters only)',
        time: 'Time',
        location_and_time_label: 'Location & Time',
        date_day_label: 'Date/Day',
        date_day_placeholder: 'Select Date/Day',
        start_time_label: 'Start Time',
        duration_label: 'Duration',
        duration_placeholder: 'Select Duration',
        check_in_label: 'Check In',
        check_out_label: 'Check Out',
        departure_airport_label: 'Departure Air Port',
        arrival_airport_label: 'Arrival Air Port',
        airport_placeholder: 'Type the airport',
        pick_up_location_label: 'Pick Up Location',
        drop_off_location_label: 'Drop Off Location',
        departure: 'Departure',
        arrival: 'Arrival',
        airline_label: 'Airline',
        airline_placeholder: 'Type the airline',
        flight_number_label: 'Flight #',
        flight_number_placeholder: 'Type the flight #',
        terminal_label: 'Terminal',
        gate_label: 'Gate',
        carrier_label: 'Carrier',
        carrier_placeholder: 'Type the carrier',
        price: 'Price',
        amount_label: 'Amount',
        amount_placeholder: 'Amount',
        currency_label: 'Currency',
        book_through_label: 'Book Through',
        book_through_placeholder: 'Type booking provider',
        confirmation_number_label: 'Confirmation #',
        confirmation_number_placeholder: 'Type confirmation #',
        file: 'File',
        attachment_label: 'Attachment',
        attachment_placeholder: 'Add file',
        save_and_exit: 'Save & Exit'
      },
      booking_steps: {
        service_fee: 'Service Fee',
        trip_to: 'Trip to ',
        trip_for_days: ' for ',
        days: 'days',
        set_travelers: 'Set travelers',
        add_info: 'Add Info',
        activities: 'Activities',
        add_services: 'Add Services',
        review_pay: 'Review and pay',
        group_type: 'Group Type',
        choose: 'Choose',
        family: 'Family',
        friends: 'Friends',
        couple: 'Couple',
        solo: 'Solo',
        group: 'Group',
        business: 'Business',
        other: 'Other',
        travelling_with: "I'm travelling with",
        full_name: 'Full name',
        age: 'Age',
        number_people: 'Number of People',
        add_traveler: 'Add another traveler',
        next: 'Next',
        describe_trip: "Describe your perfect trip. We'll make it happen",
        trip_tempo: 'Trip Tempo',
        relaxed: 'Relaxed',
        moderate: 'Moderate',
        fast: 'Fast',
        per_person: 'Per Person',
        total_trip: 'Total Trip',
        total_trip_value: 'Total',
        total_budget: 'Total Budget',
        general_comments: 'Describe your needs',
        general_sub_comments: 'Add some things...',
        things_during_stay: 'Add some of the things you would like have during your stay',
        trip_guru: 'Trip Guru:',
        summary_comments: 'General description and comments:',

        museums: 'Museums',
        historical_sites: 'Historical sites',
        art_fairs: 'Art Fairs & Galleries',
        hiking: 'Hiking',
        shrines: 'Shrines',
        temples: 'Temples',
        food_drink: 'Food and Drink',
        gardens: 'Gardens',
        castles: 'Castles',
        nature: 'Nature',
        amusement_parks: 'Amusement Parks',
        festivals: 'Festivals',

        additional_services: 'Would you like additional services to your plan?',
        ofc: 'Yes I do!',
        choose_services: 'Choose your additional services',
        HotelBooking: 'Hotels',
        FlightBooking: 'Flights',
        CarRental: 'Rent a car',
        RentHouse: 'Rent house (airbnb)',
        PublicTransport: 'Public transportation : bus / train',
        TicketsOrdering: 'Tickets',
        LocalSimCard: 'Local Sim Card',
        OnSiteMessageAssistance: 'On Site Message Assistance',

        payment_type: 'Payment type',
        cards: 'Cards',
        billing_country: 'Billing country',
        card_number: 'Card number',
        expiration: 'Expiration',
        security_code: 'Security code',
        name_on_card: 'Name on the Card',
        request_to_book: 'Request to Book',
        book_order: 'Order',

        review_summary: 'Review summary',
        your_plan: 'Your Plan:',
        coming: "Who's coming:",
        total: 'Total:',
        summary_group: 'Group type',
        summary_tempo: 'Trip Tempo:',
        summary_budget_min: 'Requested budget (min):',
        summary_budget_max: 'Requested budget (max):',
        summary_budget_type: 'Trip budget type:',
        summary_activities: 'Activities:',
        summary_services: 'Additional services',
        summary_payment: 'Payment Type:',
        view_details: 'View Details',

        back: 'Back'
      },

      activity_booking_steps: {
        set_travelers: 'Set travelers',
        review_pay: 'Review and pay',
        group_type: 'Group Type',
        choose: 'Choose',
        family: 'Family',
        friends: 'Friends',
        couple: 'Couple',
        solo: 'Solo',
        group: 'Group',
        business: 'Business',
        other: 'Other',
        travelling_with: "I'm travelling with",
        full_name: 'Full name',
        age: 'Age',
        number_people: 'Number of People',
        add_traveler: 'Add another traveler',
        next: 'Next',
        describe_trip: "Describe your perfect trip. We'll make it happen",
        trip_tempo: 'Trip Tempo',
        relaxed: 'Relaxed',
        moderate: 'Moderate',
        fast: 'Fast',
        per_person: 'Per Person',
        total_trip: 'Total Trip',
        total_trip_value: 'Total',
        total_budget: 'Total Budget',
        general_comments: 'General description and comments',
        things_during_stay: 'Add some of the things you would like have during your stay',

        payment_type: 'Payment type',
        cards: 'Cards',
        billing_country: 'Billing country',
        card_number: 'Card number',
        expiration: 'Expiration',
        security_code: 'Security code',
        name_on_card: 'Name on the Card',
        request_to_book: 'Request to Book',
        book_order: 'Order',

        place_order: 'Place your order',
        private_tour_price: 'Private tour price',
        private_tour: 'Private tour',

        your_activity: 'Your activity',
        start_date: 'Start date',

        review_summary: 'Review summary',
        coming: "Who's coming:",
        total: 'Total',
        summary_group: 'Group type',
        summary_tempo: 'Trip Tempo',
        summary_budget_min: 'Requested budget (min)',
        summary_budget_max: 'Requested budget (max)',
        summary_budget_type: 'Trip budget type',
        summary_activities: 'Activities',
        summary_services: 'Additional services',
        summary_payment: 'Payment Type',
        view_details: 'View Details',

        back: 'Back'
      },

      orders: {
        future_orders: 'Future Orders',
        completed_orders: 'Completed Orders',
        status: 'Status',
        action: 'Action',
        type: 'Type',
        details: 'Details',
        pay_to: 'Pay To',
        pay_by: 'Pay By',
        amount: 'Amount',
        date: 'Date',
        no_action: 'No Action Required',
        Museums: 'Museums',
        HistoricalSites: 'Historical sites',
        ArtFairsGalleries: 'Art Fairs & Galleries',
        Hiking: 'Hiking',
        Shrines: 'Shrines',
        Temples: 'Temples',
        food_drink: 'Food and Drink',
        Gardens: 'Gardens',
        Castles: 'Castles',
        Nature: 'Nature',
        AmusementParks: 'Amusement Parks',
        Festivals: 'Festivals',
        click_approve: 'Click to approve',
        trip_guru: 'Trip Guru',
        approve_decline: 'Approve / Decline',
        changeprice: 'Change Price',
        charged: 'Charged',
        approved: 'Approved',
        declined: 'Declined',
        neworder: 'New Order',
        new_order_here: 'You got a new order for trip planning.',
        take_action: 'Please take an action by accepting the new order.',
        cannot_deliver: 'In case you cannot deliver the best product for the client please decline it.',
        accept: 'Accept',
        decline: 'Decline',
        approve: 'Approve',
        about_to_change_price: 'You are about to change the price of the plan.',
        add_comments: 'Please add you comments for this change.',
        client_required: 'Your client will be required to approve this change.',
        total_price_before: 'Total price before changes',
        additional_charges: 'Additional charges',
        new_total_price: 'New total price',
        summary: 'Summary',
        total_payment: 'Total Payment',
        start_date: 'Start Date',
        end_date: 'End Date',
        additional_services: 'Additional Services',
        group_type: 'Group Type',
        number_people: 'Number of People',
        trip_tempo: 'Trip Tempo',
        budget_person: 'Budget per person',
        activities: 'Activities',
        button_close: 'Close',
        accept_change: 'Are sure you want to accept this change in pricing?'
      },
      payment: {
        place_order: 'Place Your Order',
        continue: 'Continue'
      },
      messenger: {
        send_button: 'Send',
        about_me: 'About me',
        messages: 'Messages',
        trip_details: 'Trip details'
      },
      photo_slider: {
        more_details: 'More Details',
        upload_picture_manually: 'Select Your Own',
        select_picture: 'Select Picture'
      },
      trip_planner: {
        add_day: 'Add Day',
        add_poi: 'Add POI',
        add_event: 'Add Event',
        add_notes: 'Add Notes',
        library: 'Library',
        library_tip: 'Click to add to the planner board',
        poi: 'POI',
        notes: 'Notes',
        events: 'Events',
        search: 'Search',
        days: 'days',
        hours: 'hours',
        minutes: 'minutes',
        one_day: 'day',
        one_hour: 'hour',
        one_minute: 'minute',
        load_day_from_plan: "Load Full Day",
        removeFav: 'Remove from Favorites',
        select_plan: "Select plan",
        select_fav_day:"Select Favorite Day",
        select_plan_day: "Select day",
        load_day: "Load Now",
        select_from_plans: "Select a plan...",
        select_from_fav: "Select a favorite...",
        select_from_plan_days: "Select a day...",
        override_events: "Override existing events"
      },
      my_trips: {
        page_title: 'My Trips',
        add_trip: 'Add Trip',
        add_prepaid_trip: 'Add Prepaid Trip',
        preview: 'Preview',
        send: 'Send',
        prepaid_order: 'Prepaid Order',
        prepaid_user: 'Enter user details for prepaid order',
        prepaid_plans: 'Select a trip for the invited user',
        prepaid_order_user_details: 'Ordering user details',
        prepaid_user_update: 'You can update the following user details',
        "get_pdf": "no pdf file",
        "pdf_from": "File from",
        "generating_pdf": "Generating pdf..."
      },
      my_trip: {
        trip_dates: 'Trip Dates',
        send_message: 'Send Message',
        "comments": "Comments"
      },
      activity_list: {
        title: 'Main title goes here',
        slogan: 'Main Slogan / Description',
        create_activity: 'Create Activity',
        add_activity: 'Add Activity',
        sample_activities: 'Sample Activities'
      },
      copy_trip_modal: {
        title: 'Title',
        order: 'Order',
        save: 'Save'
      },
      categories: {
        All: 'All',
        FoodAndDrink: 'FoodAndDrink',
        Museums: 'Museums',
        HistoricalSites: 'HistoricalSites',
        Gardens: 'Gardens',
        ArtFairsGalleries: 'ArtFairsGalleries',
        Hiking: 'Hiking',
        Shrines: 'Shrines',
        Temples: 'Temples',
        Castles: 'Castles',
        Nature: 'Nature',
        AmusementParks: 'AmusementParks',
        Festivals: 'Festivals',

        "Shopping": 'Shopping',
        "Culture": 'Culture',
        "Kids": 'Kids',
        "NightLife": 'Night Life',
        "Romance": 'Romance',
        "Trendy": 'Trendy',
        "Entertainment": 'Entertainment'
      }
    },
    he: {
      main: {
        "all_for_you": "הכל עבורך",
        "anytime": "מתי",
        "become_a_guide": "הפוך למדריך",
        "become_a_travel_guru": "הפוף לגורו טיולים",
        "become_an_activity_guide": "הפוך למדריך פעילויות",
        "birth": "נדרש 18 שנה מינימום",
        "birthday": "יומולדת",
        "browse": "דפדף",
        "content": "תוכן כאן!",
        "currency": "מטבע",
        "date_format": "יום/חודש/שנה",
        "days": "ימים",
        "duration": "משך",
        "email": "דואר אלקטרוני",
        "enter_price": "הכנס מחיר",
        "example_location": "יעד",
        "file_size_limit": "הקובץ חייב להיות פחות מ {{ }} מגה ",
        "file_type_error": "הקובץ חייב להיות מסוג {{ }} ",
        "first_name": "שם פרטי",
        "gender": "מין",
        "guided_activities": "פעילויות ",
        "guru_tailored_tours": "גורו טיולים",
        "help": "עזרה",
        "home": "עמוד הבית",
        "last_name": "שם משפחה",
        "length": "נדרש 80 תווים",
        "loading": "לינה",
        "location_must_include_country": "המיקום חייב לכלול מדינה",
        "login": "כנס לחשבון",
        "logout": "צא מהחשבון",
        "main_description": "הדרך הנוחה, הזולה, והחוויתית לטייל כמו מקומי",
        "main_title": "טיול בהתאמה אישית",
        "messages": "הודעות",
        "my_orders": "הזמנות שלי",
        "my_profile": "הפרופיל שלי",
        "name": "שם",
        "people": "אנשים",
        "phone": "טלפון",
        "price": "מחיר",
        "remove": "הסר",
        "required_field": "שדה חובה",
        "reviews": "חוות דעת",
        "save_continue": "שמור והמשך",
        "select_currency": "בחר מטבע",
        "settings": "הגדרות",
        "signup": "פתח חשבון",
        "signup_title": "השלם את הרישום בבקשה",
        "my_trips": "הטיולים שלי",
        "my_plans": "התוכניות שלי",
        "trip_activities": "טיולים / פעילויות",
        "website_error": "אתר לא נכון",
        hour: 'שעה',
        hours: 'שעות',
        minutes: 'דקות',
      },
      img_bank: {
        "input_placeholder": "כתוב את מילות המפתח",
        "search_help": "חפש באוסף התמונות",
        "select": "בחר",
        "title": "בחר את התמונות שלך",
        "upload_photo": "הוסף תמונה"
      },
      guru: {
        "add_expertise": "הוסף מומחיות (אופציונאלי)",
        "add_language": "הוסף שפה",
        "add_location": "הוסף מיקום (אופציונאלי)",
        "add_service": "הוסף שירות",
        "add_trip": "הוסף טיול (אופציונאלי)",
        "additional_services": "שירותים נוספים",
        "additional_services_message": "ציין שירותים נוספים שאתה יכול לספק למטיילים ואתה מומחה בהם",
        "additional_services_placeholder": "כותרת שירות",
        "additional_services_title": "שירותי תיירות נוספים ",
        "category": "קטגוריה",
        "category_description_title": "בחר את הקטגוריות שמתארות בצורה הטובה ביותר",
        "category_title": "קטגוריה",
        "customer_service_expectation": "ציין מה הלקוחות שלך יכולים לצפות ממך בכל הקשור לתוכנית הטיול, התקשורת מולם, והתמיכה בתהליך בניית התוכנית",
        "description": "תיאור",
        "destination": "יעד",
        "details": "פרטים",
        "duplicate_services_error": "ניתן לבחור כל שירות פעם אחת",
        "enter_plan_name": "כתוב את שם התוכנית",
        "example_file_instructions": "העלה בבקשה דוגמא לתוכנית טיול להתרשמות של לקוחות פוטנציאליים",
        "example_file_spec": "סוג קובץ: PDF עד 10 מגה",
        "example_file_title": "העלה תוכנית לדוגמא",
        "example_location": "לדוגמא: תחנת שינגיקו",
        "expertise_duplicate_error": "ניתן לבחור כל מומחיות פעם אחת ",
        "home_location_title": "אני מתגורר ב ",
        "languages": "שפות",
        "location": "מיקום",
        "location_description_title": "הוסף מיקומים בהם אתה גורו לבניית טיולים שיכול לספק תוכנית טיול מפורטת ואיכותית",
        "location_title": "מיקומים בהם אתה גורו טיולים",
        "my_details": "הפרטים שלי",
        "pal_pal_description_example": "החשבון הזה  david@david.com מאפשר לנו לשלם לך",
        "pay_pal": "תשלום",
        "pay_pal_description": "הוסף את המייל של חשבון הפייפאל שלך על מנת לאפשר לנו להעביר לך את ההכנסות",
        "photos": "הוסף תמונות",
        "plan_name": "שם התוכנית",
        "plan_payment_structure": "אופציות תמחיר",
        "plans_PayForMonth": "תשלום לעד חודש",
        "plans_PayForMoreThanMonth": "תשלום ליותר מחודש",
        "plans_PayOneWeekPeriod": "תשלום לעד שבוע",
        "plans_PayPerDay": "תשלום לפי יום",
        "plans_PayThreeWeekPeriod": "תשלום לעד שלושה שבועות",
        "plans_PayTwoWeekPeriod": "תשלום לעד שבועיים",
        "select_expertise_placeholder": "בחר מומחיות",
        "select_language": "בחר שפה",
        "service_description": "תיאור השירות",
        "service_description_example": "ציין מה הלקוחות שלך יכולים לצפות ממך בכל הקשור לתוכנית הטיול, התקשורת מולם, והתמיכה בתהליך בניית התוכנית",
        "service_description_message": "כתוב תיאור קצר (עד 800 תווים)",
        "service_description_title": "תיאור השירות",
        "service_locations": "מיקום השירות",
        "short_description": "כתוב תיאור קצר על עצמך",
        "short_description_placeholder": "הקלד תאור קצר (עד 600 תוים)",
        "special_expertise": "התמחויות מיוחדות",
        "special_expertise_description": "בחר מומחיות אשר מתארת ניסיון יוצא דופן שלך (למשל, עבודה עם אנשים בעלי מוגבלויות)",
        "tailored_trip_plans_cost": "תוכניות מותאמות ומחירים",
        "tailored_trip_plans_cost_description": "השמע אישי, הדגש את הניסיון שלך. הצג מדוע אתה גורו שמומחה בבניית טיולים. תאר כל מומחיות ייחודית, תעודות, וכן ניסיון חיים שהופך אותך לגורו. נסה לסיים עם משהו חביב או משהו מעניין כדי לא להשמע רישמי מידי. ",
        "tailored_trips": "עלות בניית טיול אישי",
        "unique_location_error": "יש לבחור כל מיקום פעם אחת בלבד",
        "upload_example": "הוסף דוגמא",
        "uploaded_file": "הקובץ עלה",
        "your_profile_summary_title": "גורו הטיולים המושלם עבורך",
        "your_profile_title": "הפרופיל שלך נראה טוב!",
        "what_will_you_get": 'מה אתה מקבל כטייל',
        "guru_including_title": 'תוכנית טיול אישית הכוללת',
        "tailored_itineraries": 'תוכנית טיול יומית פרטנית',
        "information_advices": 'מידע על אתרים בטיול',
        "tips_for": 'טיפים על אטרקציות, מקומות בילוי ועוד',
        "food_suggestions": 'המלצות על אוכל',
        "special_events": 'אירועים מיוחדים במהלך הטיול',
        "personal_app": "אפליקציה אישית לטלפון הנייד",
        "online_offering": 'תקשורת עם גורו הטיולים על מנת לבנות לך טיול מותאם אישית המבוסס על הרצונות שלכם, תקציב, תקופה. כגורו טיול אני אצור אתכם קשר כדי לקבל עוד פרטים על הטיול שלכם ולספק מענה לשאלות שיעלו',
        "reviews": "חוות דעת",
        about_me: "קצת עלי"
      },
      guide: {
        "about_me": "מי אני ",
        "add_category": "הוסף קטגוריה (אופציונאלי)",
        "add_language": "הוסף שפה",
        "add_location": "הוסף מיקום (אופציונאלי)",
        "add_photos": "הוסף תמונות",
        "category": "קטגוריה",
        "chance_picked": "תמונות מעלות את הסיכוי לרכישה ב 80%. הצג 3 תמונות ",
        "description": "תיאור",
        "detailed_plan": "תוכנית טיול מפורטת ",
        "details": "פרטים",
        "example_location": "לדוגמא: תחנת שינגקו",
        "finish": "סיום",
        "helps_you": "מסייע לך בכל צעד בטיול שלך",
        "home_location_title": "אני מתגורר ב",
        "languages": "שפות",
        "langueges_label": "ציין את השפות שבהן הפעילות ניתנת ",
        "location": "מיקום",
        "location_title": "מדינה",
        "main_info": "מידע ראשי",
        "my_details": "הפרטים שלי",
        "online_support": "תמיכת אונליין ש",
        "photos": "הוסף תמונות",
        "quality_photos": "הוסף תמונות איכותיות ",
        "remove": "הסר",
        "save_continue": "שמור והמשך",
        "select_category": "בחר קטגוריה",
        "select_language": "בחר שפה",
        "short_description": "כתוב תיאור קצר על עצמך",
        "short_description_example": "השמע אישי, הדגש את הניסיון שלך. הצג מדוע אתה גורו שמומחה בבניית טיולים. תאר כל מומחיות ייחודית, תעודות, וכן ניסיון חיים שהופך אותך לגורו. נסה לסיים עם משהו חביב או משהו מעניין כדי לא להשמע רישמי מידי. ",
        "short_description_placeholder": "כתוב תאור קצר (עד 600 תווים)",
        "solves_question": "פותר את כל השאלות שלך",
        "solves_questions": "פותר את כל השאלות שלך",
        "unique_location_error": "כל מיקום נבחר פעם אחת בלבד",
        "what_you_get": "מה אתה מקבל",
        "your_profile_summary_title": "סיכום פרופיל המומחה שלך",
        "your_profile_title": "הפרופיל שלך נראה טוב!"
      },
      activity_steps: {
        "activity_description": "ציין בפירוט מה אתה הולך לעשות עם המשתתפים בפעילות. ",
        "add_category": "הוסף קטגוריה (אופציונאלי)",
        "add_event": "הוסף אירוע (אופציונאלי)",
        "add_info": "הוסף מידע",
        "add_language": "הוסף שפה (אופציונאלי)",
        "add_notes": "הוסף הערות",
        "add_photos": "הוסף תמונות",
        "add_tags": "הוסף תגים לשיפור תוצאות החיפוש ",
        "booking_notice": "הודעת הזמנה",
        "bring_description": "כתוב תאור קצר על מה המשתתפים צריכים להביא לפעילות",
        "bring_spec": "ציין כל דבר שהמשתתפים צריכים להביא איתם או להזמין בעצמם כגון, תחבורה, נעלים נוחות, קרם הגנה וכיוב׳ ",
        "categories": "קטגוריות",
        "category": "קטגוריה",
        "category_description_title": "בחר את הקטגוריות המתארות בצורה הטובה ביותר את הפעילות",
        "chance_picked": "תמונות טובות מעלות את הסיכוי לרכישה ב 80%. הצג שלוש תמונות טובות. ",
        "currency_label": "מטבע",
        "days_before": "מספר ימים לפני",
        "defines_languages": "ציין את השפות שבהן אתה מעביר את הפעילות",
        "description": "תיאור",
        "duration": "משך זמן",
        "endDate": "תאריך סיום",
        "event_dates": "תאריכי האירועים",
        "example_description_spec": "לדוגמא: טיול לכל המשפחה. פעילות קניות יחודית במקומות הכי טרנדים וזולים",
        "example_location": "לדוגמא: תחנת הרכבת שיבוייה",
        "group_price": "מחיר בקבוצה",
        "group_size": "גודל קבוצה",
        "hours_day": "שעות ביום",
        "languages": "שפות",
        "length_price": "אורך הפעילות, גודל הקבוצה ומחיר ",
        "main_info": "מידע עיקרי",
        "meet_travelers": "ציין היכן אתה הולך לפגוש את המשתתפים בפעילות",
        "meeting_point": "נקודת מפגש",
        "meeting_point_description": "ציין עבור המשתתפים את נקודת המפגש המדוייקת. ",
        "more_details": "פרטים נוספים",
        "need_to_bring": "מה המשתתפים צריכים להביא איתם",
        "notify_people": "ציין מתי לתזכר את המשתתפים לגבי הפעילות",
        "price_per_person": "מחיר למשתתף ",
        "private_tour": "מחיר לפעילות פרטית",
        "private_tour_price": "מחיר פעילות פרטית",
        "provide_description": "ציין פרטים נוספים על מה ",
        "provide_spec": "לדוגמא: כרטיסים לרכבת, קופון הנחה",
        "publish_activity": "פרסם את הפעילות",
        "quality_photos": "הוסף תמונות איכותיות",
        "repeat": "חזור",
        "security_example": "ציין כל דבר שהמשתתפים צריכים לדעת בנושא בטיחות",
        "security_notice": "הערת בטיחות",
        "select_category": "בחר קטגוריה",
        "select_language": "בחר שפה",
        "short_description": "כתוב תאור קצר של הפעילות",
        "short_description_placeholder": "הכנס תאור קצר ",
        "starting_hour": "שעת התחלה",
        "tags_placeholder": "הכנס תגים: משפחה, קניות, אוכל",
        "times_location": "זמן / מיקום",
        "title-tags": "כותרת, מיקום, תגים",
        "tour_length": "משך זמן הפעילות",
        "tour_price": "מחיר הפעילות",
        "tour_price_description": "מחיר הפעילות הוא לשיקול דעתך הבלעדי",
        "trip_dates": "תאריכי אירוע",
        "trip_title": "כותרת ומיקום הפעילות",
        "type_title": "כותרת הפעילות",
        "view_details": "הצג פרטים",
        "weather_example": "ציין כל דבר שהמשתתפים צריכים לדעת בנושא מזג האוויר, כגון האם להביא מטריה, בקבוק מים, וכיוב׳. ",
        "weather_notice": "הערת מזג אוויר",
        "what-to-do": "מה נעשה",
        "what_bring": "מה אתה צריך להביא ",
        "what_i_provide": "מה אני מספק",
        "what_we_do": "מה אנחנו נעשה",
        "what_you_provide": "מה אני מספק",
        "where_description": "ציין את כל המקומות שתבקרו בפעילות. תן למשתתפים את ההבנה מדוע מקומות אלה חשובים",
        "where_description_spec": "לדוגמא: אנחנו נבקר בחנויות הטובות ביותר בטוקיו לבגדים. ",
        "where_will_be": "איפה נהיה"
      },
      create_trip: {
        "add_another_traveler": "הוסף מטייל נוסף",
        "add_cover_photo": "הוסף תמונת טיול",
        "budget": "תקציב",
        "currency": "מטבע",
        "day_prefix": "יום",
        "description_example": "לדוגמא: כרטיסים לרכבת, קופון",
        "description_label": "כתוב תאור קצר על הטיול שלך",
        "description_placeholder": "כתוב תאור קצר",
        "end_date": "תאריך סיום",
        "for_person": "למשתתף",
        "full_name_label": "שם מלא",
        "name_and_date": "שם ותאריך",
        "name_label": "שם",
        "name_placeholder": "כתוב את שם הטיול",
        "next": "הבא",
        "order": "הזמנה",
        "page_title": "צור טיול",
        "start_date": "תאריך התחלה",
        "total": "סה״כ",
        "total_days": "סה״כ ימים",
        "traveler_age": "גיל",
        "traveler_name_placeholder": "שם מלא",
        "travelers": "מטיילים"
      },
      overview: {
        "add_info": "הוסף מידע",
        "bring_spec": "לדוגמא: נעליים נוחות, קרם הגנה",
        "choose": "בחר",
        "security_notice": "הערת בטיחות",
        "see_dates": "ראה תאריכים",
        "show_more": "הצג עוד",
        "weather_notice": "הערת מזג אוויר",
        "what_bring": "מה אתה צריך להביא",
        "what_i_provide": "מה אני מספק",
        "what_we_do": "מה אנחנו עושים",
        "what_you_provide": "מה אני מספק",
        "where_will_be": "איםה אנחנו נהיה"
      },
      profile: {
        "birthday": "יומולדת",
        "country": "מדינה",
        "email": "כתובת דואר אלקטרוני",
        "email_placeholder": "כתוב את כתובת הדואר שלך",
        "english": "אנגלית",
        "female": "נקבה",
        "first_name": "שם פרטי",
        "first_name_placeholder": "כתוב את השם הפרטי שלך",
        "gender": "מין",
        "hebrew": "עברית",
        "help_avatar": "הדבר הראשון שאנשים רואים זה את התמונה שלך, הצג להם את הטובה ביותר ",
        "help_birthday": "אנחנו עושים שימוש במידע זה לניתוחים ולא משתפים אותו עם אף משתמש",
        "help_country": "אנשים מתעניים מאיפה אתה",
        "help_currency": "אנחנו נציג לך את המחירים במטבע זה ",
        "help_email": "אנחנו לא נשתף את המייל האישי שלך עם משתמשים אחרים. המייל שלך מועבר רק לספק ממנו ביצעת הזמנה בפועל. זאת הדרך הטובה לייצא ביניכם את הקשר. ",
        "help_gender": "אנחנו עושים שימוש במידע זה לניתוחים ולא משתפים אותו עם אף משתמש",
        "help_language": "שפה מועדפת עליך להתקשרות",
        "help_names": "הפרופיל שלך יוצג למשתמשים אחרים רק עם השם הפרטי. כאשר אתה מבצע הזמנה הספקים יראו את השם הפרטי ושם המשפחה",
        "help_phone": "אנחנו לא משתפים את מספר הטלפון שלך עם משתמשים אחרים. הטלפון שלך מועבר לספק רק במידה וביצעת הזמנה וזאת לצרכי התקשרות בלבד. ",
        "last_name": "שם משפחה",
        "last_name_placeholder": "כתוב את השם הפרטי שלך",
        "male": "זכר",
        "other": "אחר",
        "phone": "מספר טלפון",
        "phone_placeholder": "כתוב את הטלפון שלך",
        "pr_picture": "תמונת פרופיל",
        "pref_curency": "מטבע מועדף",
        "pref_language": "שפה מועדפת",
        "save": "שמור",
        "spanish": "ספרדית",
        "title": "ערוך פרופיל "
      },
      create_poi: {
        "add_photo": "הוסף תמונה",
        "description_example": "לדוגמא: מסעדת סושי מצויינת בשיבויה, צמוד לחנות זארה",
        "description_label": "כתוב תאור קצר על נקודת העניין",
        "description_placeholder": "כתוב תאור קצר ",
        "find_poi": "מצא נקודת עניין",
        "link_label": "קישור",
        "link_placeholder": "הכנס קישור או כתובת האתר",
        "location_label": "מיקום",
        "location_placeholder": "הכנס מיקום",
        "page_title": "צור נקודת עניין",
        "phone_label": "טלפון",
        "phone_placeholder": "מספר טלפון",
        "places_label": "מקומות",
        "places_placeholder": "חפש מקום",
        "save_and_exit": "שמור וצא",
        "working_hours": "שעות עבודה"
      },
      poi_review: {
        "agriment": "אני מסכים לתנאי השימוש של כתיבת חוות דעת",
        "description_example": "הניסיון שלך עם נקודת העניין ",
        "description_label": "הניסיון האישי שלך מסייע למטיילים אחרים",
        "description_placeholder": "הקלד טקסט",
        "save": "שמור",
        "text_p1": "אנחנו מציגים את השם שלך כ ״",
        "text_p2": "״ צמוד לחוות הדעת"
      },
      tripGuru_review: {
        "agriment": "אני מסכים לתנאים והדרישות של חוות דעת",
        "description_example": "הניסיון שלך עם גורו הטיולים",
        "description_label": "חוות הדעת שלך מסייעת למטיילים אחרים",
        "description_placeholder": "כתוב טקסט",
        "save": "שמור",
        "text_p1": "המערכת תציג את השם שלך כ ״",
        "text_p2": "״ צמוד לחוות הדעת הזו"
      },
      localTour_review: {
        "agriment": "אני מסכים לתנאי השימוש של חוות הדעת",
        "description_example": "הניסיון שלך עם הפעילות",
        "description_label": "הניסיון האישי שלך מסייע למטיילים נוספים",
        "description_placeholder": "הקלד טקסט",
        "save": "שמור",
        "text_p1": "אנחנו נציג את השם שלך כ ״",
        "text_p2": "״ צמוד לחוות הדעת"
      },
      edit_poi: {
        "add_photo": "הוסף תמונה",
        "description_example": "לדוגמא: סושי מצוין בשיבויה בצמוד לחנות זארה",
        "description_label": "כתוב תאור קצר על נקודת העניין",
        "description_placeholder": "כתוב תיאור קצר ",
        "find_poi": "מצא נקודת עניין",
        "link_label": "קישור",
        "link_placeholder": "הוסף קישור או כתובת של האתר",
        "location_label": "מיקום",
        "location_placeholder": "כתוב מיקום",
        "page_title": "ערוך נקודת עניין",
        "phone_label": "טלפון",
        "phone_placeholder": "מספר טלפון",
        "places_label": "מקומות",
        "places_placeholder": "חפש מקום",
        "save_and_exit": "עדכן",
        "working_hours": "שעות עבודה"
      },
      add_notes: {
        "create": "צור",
        "description": "תאור",
        "description_example": "לדוגמא: כרטיס לרכבת, קופון",
        "description_label": "כתוב תאור קצר על ההערה שלך",
        "description_placeholder": "כתוב תאור קצר (עד 100 תווים)",
        "page_title": "הוסף הערות",
        "save_and_exit": "שמור",
        "title_label": "כותרת",
        "title_placeholder": "כותרת"
      },
      edit_notes: {
        "create": "צור",
        "description": "תאור",
        "description_example": "לדוגמא: כרטיסים לרכבת, קופון",
        "description_label": "כתוב תאור קצר על ההערות שלך",
        "description_placeholder": "כתוב תאור קצר",
        "page_title": "ערוך הערות",
        "save_and_exit": "שמור",
        "title_label": "כותרת",
        "title_placeholder": "כותרת"
      },
      event: {
        "airline_label": "חברת תעופה",
        "airline_placeholder": "כתוב את חברת התעופה",
        "airport_placeholder": "כתוב את נמל התעופה",
        "amount_label": "סכום",
        "amount_placeholder": "סכום",
        "arrival": "הגעה",
        "arrival_airport_label": "נמל תעופה הגעה",
        "attachment_label": "קובץ",
        "attachment_placeholder": "הוסף קובץ",
        "book_through_label": "הזמן באמצעות",
        "book_through_placeholder": "כתוב את ספק ההזמנה",
        "carrier_label": "חברה מובילה",
        "carrier_placeholder": "כתוב את החברה המובילה",
        "category_label": "קטגוריה ",
        "category_placeholder": "בחר קטגוריה",
        "check_in_label": "כניסה",
        "check_out_label": "עזיבה",
        "confirmation_number_label": "מספר אישור",
        "confirmation_number_placeholder": "הכנס מספר אישור",
        "currency_label": "מטבע",
        "date_day_label": "תאריך / יום",
        "date_day_placeholder": "בחר תאריך / יום",
        "departure": "עזיבה ",
        "departure_airport_label": "נמל תעופה יוצאים",
        "description_example": "לדוגמא: מוזיאון האומנות הפתוח הוא המקום המוביל בהאקונה",
        "description_label": "כתוב תיאור קצר על האירוע ",
        "description_placeholder": "כתוב את התיאור הקצר עד 600 תווים",
        "drop_off_location_label": "יעד החזרה",
        "duration_label": "משך זמן",
        "duration_placeholder": "בחר משך זמן",
        "file": "קובץ",
        "flight_number_label": "מספר טיסה",
        "flight_number_placeholder": "כתוב את מספר הטיסה",
        "gate_label": "שער",
        "link__label": "קישור",
        "link__placeholder": "כתוב קישור",
        "location_and_time_label": "מיקום וזמן",
        "location_label": "מיקום",
        "location_placeholder": "חפש מיקום",
        "page_title": "אירוע",
        "pick_up_location_label": "נקודת איסוף",
        "place_label": "מיקום",
        "place_placeholder": "חפש מיקום",
        "places": "מקומות",
        "price": "מחיר",
        "save_and_exit": "שמור וצא",
        "start_time_label": "שעת התחלה",
        "sub_category_label": "קטגורית משנה",
        "sub_category_placeholder": "בחר קטגורית משנה",
        "terminal_label": "טרמינל",
        "time": "זמן",
        "title_label": "כותרת",
        "title_placeholder": "כתוב את הכותרת שלך"
      },
      booking_steps: {
        "CarRental": "השכרת רכב",
        "FlightBooking": "טיסות",
        "HotelBooking": "מלונות",
        "LocalSimCard": "כרטיס סים מקומי",
        "OnSiteMessageAssistance": "תמיכה אונליין במהלך הטיול",
        "PublicTransport": "תחבורה ציבורית: אוטובוס / רכבת ",
        "RentHouse": "השכרת דירה (airbnb)",
        "TicketsOrdering": "כרטיסים",
        "activities": "פעילויות ",
        "add_info": "הוסף מידע",
        "add_services": "הוסף שירותים",
        "add_traveler": "הוסף משתתף נוסף",
        "additional_services": "האם אתה מעוניין להוסיף שירותים נוספים לתוכנית הטיול שלך? ",
        "age": "גיל",
        "amusement_parks": "פארקי שעשועים",
        "art_fairs": "ירידי אומנות וגלריות",
        "back": "חזור",
        "billing_country": "ארץ לחיוב",
        "book_order": "הזמן",
        "business": "עסקי",
        "card_number": "מספר כרטיס",
        "cards": "כרטיסים",
        "castles": "טירות",
        "choose": "בחר",
        "choose_services": "בחר את השירותים הנוספים מהרשימה ",
        "coming": "מי משתתף",
        "couple": "זוג",
        "days": "ימים",
        "describe_trip": "תאר את הטיול המושלם עבורך, דגש על מה אתה אוהב ורוצה לראות ואנחנו נדאג לבנות אותו. ",
        "expiration": "תוקף",
        "family": "משפחה",
        "fast": "מהר",
        "festivals": "פסטיבלים",
        "food_drink": "אוכל ומשקאות",
        "friends": "חברים",
        "full_name": "שם מלא",
        "gardens": "גנים",
        "general_comments": "תאר את הצרכים והרצונות שלך בטיול",
        "general_sub_comments": "הוסף משהו",
        "group": "קבוצה",
        "group_type": "סוג קבוצה",
        "hiking": "טיול רגלי",
        "historical_sites": "אתרים היסטוריים",
        "moderate": "בינוני",
        "museums": "מוזיאונים",
        "name_on_card": "שם בעל הכרטיס",
        "nature": "טבע",
        "next": "הבא",
        "number_people": "מספר משתתפים",
        "ofc": "כן אני מעוניין!",
        "other": "אחר",
        "payment_type": "סוג תשלום",
        "per_person": "לאדם משתתף",
        "relaxed": "רגוע",
        "request_to_book": "בקשה להזמנה",
        "review_pay": "אשר ושלם",
        "review_summary": "סיכום",
        "security_code": "קוד אבטחה",
        "service_fee": "שירות",
        "set_travelers": "כתוב משתתפים",
        "shrines": "מקדשים יפניים",
        "solo": "לבד",
        "summary_activities": "פעילויות:",
        "summary_budget_max": "תקציב מקסימלי: ",
        "summary_budget_min": "תקציב מינימאלי:",
        "summary_budget_type": "סוג תקציב",
        "summary_comments": "תאור כללי והערות:",
        "summary_group": "סוג קבוצה",
        "summary_payment": "סוג תשלום",
        "summary_services": "שירותים נוספים",
        "summary_tempo": "קצב טיול:",
        "temples": "מקדשים",
        "things_during_stay": "הוסף את הדברים שהייתי רוצה לעשות במהלך הטיול שלך",
        "total": "סה״כ:",
        "total_budget": "תקציב כולל",
        "total_trip": "סה״כ לטיול",
        "total_trip_value": "סה״כ",
        "travelling_with": "אני מטייל עם:",
        "trip_for_days": "עבור",
        "trip_guru": "גורו טיולים:",
        "trip_tempo": "קצב טיול",
        "trip_to": "טיול ל",
        "view_details": "ראה פרטים",
        "your_plan": "התוכנית שלך:"
      },

      activity_booking_steps: {
        "add_traveler": "הוסף מטייל נוסף",
        "age": "גיל",
        "back": "חזור",
        "billing_country": "ארץ תשלום",
        "book_order": "הזמנה",
        "business": "עסק",
        "card_number": "מספר כרטיס",
        "cards": "כרטיסים",
        "choose": "בחר",
        "coming": "מי מגיע:",
        "couple": "זוג",
        "describe_trip": "תאר את הצרכים והדרישות שלך מהטיול ואנחנו נבנה אותו",
        "expiration": "תאריך תפוגה ",
        "family": "משפחה",
        "fast": "מהיר",
        "friends": "חברים",
        "full_name": "שם מלא",
        "general_comments": "תאור כללי והערות",
        "group": "קבוצה",
        "group_type": "סוג קבוצה",
        "moderate": "בינוני",
        "name_on_card": "שם בעל הכרטיס",
        "next": "הבא",
        "number_people": "מספר משתתפים",
        "other": "אחר",
        "payment_type": "סוג תשלום",
        "per_person": "לאדם משתתף",
        "place_order": "שלח את ההזמנה",
        "private_tour": "טיול פרטי",
        "private_tour_price": "עלות טיול פרטי",
        "relaxed": "רגוע",
        "request_to_book": "בקשה להזמנה",
        "review_pay": "סכום ותשלום",
        "review_summary": "סכום",
        "security_code": "קוד אבטחה",
        "set_travelers": "קבע משתתפים",
        "solo": "לבד",
        "start_date": "תאריך התחלה",
        "summary_activities": "פעילויות",
        "summary_budget_max": "תקציב מקסימלי",
        "summary_budget_min": "תקציב מינימאלי",
        "summary_budget_type": "סוג תקציב",
        "summary_group": "סוג קבוצה",
        "summary_payment": "סוג תשלום",
        "summary_services": "שירותים נוספים",
        "summary_tempo": "קצב טיול",
        "things_during_stay": "הוסף את הדברים שהייתה מעוניין לעשות במהלך הטיול שלך",
        "total": "סה״כ",
        "total_budget": "תקציב כולל",
        "total_trip": "סה״כ לטיול",
        "total_trip_value": "סה״כ",
        "travelling_with": "אני מטייל עם",
        "trip_tempo": "קצב טיול",
        "view_details": "ראה פרטים",
        "your_activity": "הפעילות שלך"
      },

      orders: {
        "AmusementParks": "פארקי שעשועים",
        "ArtFairsGalleries": "ירידי אומנות וגלריות",
        "Castles": "טירות",
        "Festivals": "פסטיבלים",
        "Gardens": "גנים",
        "Hiking": "הליכה רגלית",
        "HistoricalSites": "אתרים היסטוריים",
        "Museums": "מוזיאונים",
        "Nature": "טבע",
        "Shrines": "מקדשים יפניים",
        "Temples": "מקדשים",
        "about_to_change_price": "אתה עומד לשנות את מחיר התוכנית",
        "accept": "קבל",
        "accept_change": "אתה בטוח שאתה מעוניין לקבל את השינוי בעלות?",
        "action": "פעולה",
        "activities": "פעילויות",
        "add_comments": "הוסף את ההערות שלך לשינוי זה",
        "additional_charges": "חיובים נוספים",
        "additional_services": "שירותים נוספים",
        "amount": "סכום",
        "approve": "אשר",
        "approve_decline": "אשר / דחה",
        "approved": "אושר",
        "budget_person": "תקציב למשתתף",
        "button_close": "סגור",
        "cannot_deliver": "במידה ואינך יכול לספק ללקוח את המוצר הטוב ביותר ובזמן אנא דחה את ההזמנה.",
        "changeprice": "שינוי מחיר",
        "charged": "חויב",
        "click_approve": "הקלק לאישור",
        "client_required": "הלקוח ידרש לאשר שינוי זה ",
        "completed_orders": "הזמנות שסופקו",
        "date": "תאריך",
        "decline": "דחה",
        "declined": "נדחה",
        "details": "פרטים",
        "end_date": "תאריך סיום",
        "food_drink": "אוכל ושתייה ",
        "future_orders": "הזמנות",
        "group_type": "סוג קבוצה",
        "new_order_here": "קיבלת הזמנה חדשה לתכנון טיול",
        "new_total_price": "סה״כ מחיר חדש",
        "neworder": "הזמנה חדשה",
        "no_action": "לא נדרשת פעולה",
        "number_people": "מספר משתתפים",
        "pay_by": "תשלום באמצעות",
        "pay_to": "תשלום ל",
        "start_date": "תאריך התחלה ",
        "status": "סטטוס",
        "summary": "סיכום",
        "take_action": "אנא טפל בהזמנה ע״י קבלה של ההזמנה החדשה",
        "total_payment": "סה״כ לתשלום",
        "total_price_before": "מחיר כולל לפני השינויים",
        "trip_guru": "גורו טיולים",
        "trip_tempo": "קצב טיול",
        "type": "סוג"
      },
      payment: {
        "continue": "המשך",
        "place_order": "בצע הזמנה"
      },
      messenger: {
        "about_me": "אודותי",
        "messages": "הודעות",
        "send_button": "שלח",
        "trip_details": "פרטי הטיול"
      },
      photo_slider: {
        "more_details": "פרטים נוספים",
        "select_picture": "בחר תמונה",
        "upload_picture_manually": "בחר את שלך"
      },
      trip_planner: {
        "add_day": "הוסף יום",
        "add_event": "הוסף אירוע",
        "add_notes": "הוסף הערות",
        "add_poi": "הוסף נקודת עניין",
        "days": "ימים",
        "events": "אירועים",
        "hours": "שעות",
        "library": "ספריה",
        "library_tip": "הקלק כדי להוסיף ללוח התכנון",
        "minutes": "דקות",
        "notes": "הערות",
        "one_day": "יום",
        "one_hour": "שעה",
        "one_minute": "דקות",
        "poi": "נקודת עניין",
        "search": "חפש",
        load_day_from_plan: "טען יום מתוכנית",
        removeFav: 'הסר מהמועדפים',
        select_fav_day:"בחר יום מועדף",
        select_plan: "בחר תוכנית",
        select_plan_day: "בחר יום",
        load_day: "טען עכשיו",
        select_from_plans: "בחר תוכנית...",
        select_from_fav: "בחר מועדף...",
        select_from_plan_days: "בחר יום...",
        override_events: "דרוס אירועים קיימים"
      },
      my_trips: {
        "page_title": 'הטיולים שלי',
        "add_prepaid_trip": "הוסף טיול פריפייד",
        "add_trip": "הוסף טיול",
        "page_title": "רשימת הטיולים",
        "prepaid_order": "הזמנת פריפייד",
        "prepaid_plans": "בחר טיול עבור המשתמש שאתה מזמין",
        "prepaid_user": "הכנס את פרטי המשתמש עבור הזמנת פריפייד",
        "preview": "הצג",
        "send": "שלח",
        "get_pdf": "אין קובץ",
        "pdf_from": "קובץ מתאריך",
        "generating_pdf": "מייצר קובץ..."
      },
      my_trip: {
        "send_message": "שלח הודעה",
        "trip_dates": "תאריכי הטיול",
        "comments": "הערות"
      },
      activity_list: {
        "add_activity": "הוסף פעילות",
        "create_activity": "צור פעילות",
        "sample_activities": "פעילויות לדוגמא",
        "slogan": "סלוגן עיקרי / תיאור ",
        "title": "כותרת ראשית לכאן"
      },
      copy_trip_modal: {
        "order": "הזמנה",
        "save": "שמור",
        "title": "כותרת"
      },
      categories: {
        "All": "כולם",
        "AmusementParks": "פארקי שעשועים",
        "ArtFairsGalleries": "תערוכות וגלריות",
        "Castles": "טירות",
        "Festivals": "פסטיבלים",
        "FoodAndDrink": "אוכל ושתיה",
        "Gardens": "גנים",
        "Hiking": "הליכה רגלית",
        "HistoricalSites": "אתרים היסטוריים",
        "Museums": "מוזיאונים",
        "Nature": "טבע",
        "Shrines": "מקדשים יפניים",
        "Temples": "מקדשים",
      }
    },
    de: {
      main: {
        loading: 'Laden',
        content: 'Inhalt hier!',
        help: 'Hilfe',
        messages: 'Mitteilungen'
      }
    }
  },
  fallbackLng: 'en',

  // have a common namespace used around the full app
  ns: ['main'],
  defaultNS: 'main',

  keySeparator: true,
  interpolation: {
    escapeValue: false,
    formatSeparator: ',',
    format: function(value, format, lng) {
      return moment(value).format('YYYY/MM/DD')
    }
  },
  react: {
    wait: true,
    nsMode: 'default'
  }
})

export default i18n

export function isRTL (lang) {
  return lang === 'he'
}

export function isCurrentLanguageRTL () {
  return isRTL(getDefaultLanguage())
}

export function getDefaultLanguage() {
  return i18n.language ? i18n.language : 'en'
}


// WEBPACK FOOTER //
// src/i18n.js